import * as React from "react";
import {
  Box, Grid, Paper, TextField, InputAdornment, Chip,
  Stack, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Typography
} from "@mui/material";
import {
  Search as SearchIcon,
  Home as HomeIcon,
  PointOfSale as PosIcon,
  ReceiptLong as ReceiptLongIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  WarehouseOutlined,
  LocationOnOutlined,
} from "@mui/icons-material";

import ProductCard from "./productcard";
import InvoicePanel from "./invoicepanel";
import AbrirTurnoDialog from "../gestion_turnos/abrirturnodialog";
import CerrarTurnoDialog from "../gestion_turnos/cerrarturnodialog";
import MetodoDePagoDialog from "../components/metododepagodialog";  
import AlertMessageDialog from "../../../../components/Dialogs/alertMessageDialog";
import { impresionrecibopagopos } from "../../prestamos/pagos/imprimirpagos";

const MOCK_PRODUCTS = [
  { id: "p1", name: "juwuw", price: 120, stock: 5, kind: "product", favorite: true },
  { id: "p2", name: "kdkd", price: 5, stock: 5, kind: "product" },
  { id: "s1", name: "Cambio de aceite", price: 850, stock: null, kind: "service" },
];

const DEFAULT_CLIENT = { id: "walkin", name: "Consumidor final" };



export default function VentasScreen(props) {
  const [search, setSearch] = React.useState("");
  const [catalog, setCatalog] = React.useState(MOCK_PRODUCTS);
  const [iniciales, setIniciales] = React.useState([]);
  const [cart, setCart] = React.useState([]);
  const [priceList, setPriceList] = React.useState("general");
  const [invoiceType, setInvoiceType] = React.useState("cf01");
  const [client, setClient] = React.useState(DEFAULT_CLIENT);
  const [showClientDialog, setShowClientDialog] = React.useState(false);
  const [currentShift, setCurrentShift] = React.useState(null);
  const [showShiftDialog, setShowShiftDialog] = React.useState(false);
  const [showCloseShiftDialog, setShowCloseShiftDialog] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [showPaymentMethodDialog, setShowPaymentMethodDialog] = React.useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null);
  const [paymentAmount, setPaymentAmount] = React.useState(0);
  const [paymentReference, setPaymentReference] = React.useState("");
  const [openAlert, setOpenAlert] = React.useState(false);

  const handlePaymentMethod = (method, amount, reference) => {
    setSelectedPaymentMethod(method);
    setPaymentAmount(amount);
    setPaymentReference(reference);
    setShowPaymentMethodDialog(true);
  };





  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/pos?idalmacen=${localStorage.getItem('id_almacen')}`,{
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
        'X-company-ID': localStorage.getItem('idcompany')
      }
    })
      .then(response => response.json())
      .then(data => {setCatalog(data.productos.filter(p => !data.iniciales.some(i => i.id_producto === p.id)));setIniciales(data.iniciales);})
      .catch(error => console.error('Error:', error));
  }, []);

  const filtered = React.useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return catalog.filter(p => !iniciales.some(i => i.id_producto === p.id));
    return catalog.filter((p) => p.nombre_producto.toLowerCase().includes(q) && !iniciales.some(i => i.id_producto === p.id));
  }, [search, catalog]);

    const addToCart = (item) => {
     
      setCart((prev) => {
        const found = prev.find((r) => r.id === item.id);
        if (found) {
          // Check stock limit before increasing quantity
          const stockLimit = item.cantidad;
          if (stockLimit === null || found.qty < stockLimit) {
            return prev.map((r) => (r.id === item.id ? { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price } : r));
          }
          return prev; // Return unchanged if at limit
        }
        // For new items, always allow adding (qty will be 1)
        return [...prev, { 
          id: item.id, 
          id_producto: item.id,
          name: item.nombre_producto, 
          price: item.precio, 
          qty: 1, 
          total: item.precio 
        }];
      });
    };
  const increase = (id) => setCart((p) => p.map((r) => {
    if (r.id === id) {
      // Find the product in catalog to get stock limit
      const product = catalog.find(item => item.id === id);
      const stockLimit = product?.cantidad;
      
      // Only increase if stock is null (unlimited) or current quantity is less than stock
      if (stockLimit === null || r.qty < stockLimit) {
        return { ...r, qty: r.qty + 1, total: (r.qty + 1) * r.price };
      }
      return r; // Return unchanged if at limit
    }
    return r;
  }));
  const decrease = (id) => setCart((p) => p.map((r) => (r.id === id && r.qty > 1 ? { ...r, qty: r.qty - 1, total: (r.qty - 1) * r.price } : r)));
  const removeItem = (id) => setCart((p) => p.filter((r) => r.id !== id));

  const generateInvoiceNumber = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const time = String(now.getTime()).slice(-6);
    return `${invoiceType.toUpperCase()}-${year}${month}${day}-${time}`;
  };

  const processSale = async (paymentData) => {
    if (cart.length === 0 || !paymentData) {
      return;
    }


    try {
        const saleData = {
          idcompany: localStorage.getItem('idcompany'), // Get from context/props
          id_sucursal: localStorage.getItem('id_sucursal'), // Get from context/props
          id_cliente: client.id === "walkin" ? null : client.id,
          tipo_comprobante: invoiceType,
          numero_comprobante: generateInvoiceNumber(),
          subtotal: totals.subtotal,
          impuestos: totals.taxes,
          total: totals.total,
          metodo_pago: paymentData["payments"].map(p => {return {method:p.method,amount:p.amount,reference:p.reference}}), // Add payment method selection
          items: cart.map(item => ({
            id_producto: item.id_producto,
            cantidad: item.qty,
            precio_unitario: item.price,
            subtotal: item.total
          })),
          created_by: localStorage.getItem('id'), // Get from auth context
        };
  
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pos/sales`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Usuario-ID': localStorage.getItem('id'),
            'X-company-ID': localStorage.getItem('idcompany')
          },
          body: JSON.stringify(saleData)
        });
  
        const result = await response.json();
  
        if (result.success) {
          setOpenAlert(true);
          impresionrecibopagopos(localStorage.getItem('nombre_compania'),"Recibo de venta",cart,new Date().toLocaleDateString());

          setTimeout(() => {
            window.location.reload();
          }, 1000);
          setCart([]); // Clear cart
          // You could also print receipt, open drawer, etc.
        } else {
          alert(`Error al procesar la venta: ${result.message}`);
        }
      } catch (error) {
        console.error('Error processing sale:', error);
        alert('Error al procesar la venta. Intente nuevamente.');
      }
    
  
  };

  const totals = React.useMemo(() => {
    const subtotal = cart.reduce((s, r) => s + parseFloat(r.total), 0);
    const taxes = 0;
    return { subtotal, taxes, total: subtotal + taxes };
  }, [cart]);

  React.useEffect(() => {
    setCart((prev) =>
      prev.map((r) => {
        const base = MOCK_PRODUCTS.find((p) => p.id === r.id)?.price ?? r.price;
        const price = priceList === "mayor" ? base * 0.95 : base;
        return { ...r, price, total: price * r.qty };
      })
    );
  }, [priceList]);

  const navItems = [
    { icon: <HomeIcon />, label: "Inicio" },
    { icon: <PosIcon />, label: "Facturar" },
    { icon: <ReceiptLongIcon />, label: "Comprobantes" },
    { icon: <PeopleIcon />, label: "Clientes" },
    { icon: <SettingsIcon />, label: "Configuración" },
  ];

  return (
    <>
      <Grid container spacing={2}>
          <Grid item size={8}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, bgcolor: "white" }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Buscar productos"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Stack>

                    <Grid container spacing={2} mt={1}>
                      {filtered.map((p) => (
                        <Grid key={p.id} item xs={12} sm={6} md={4} lg={3}>
                          <ProductCard item={p} onAdd={addToCart} selected={cart.some(item => item.id === p.id)} qty={cart.find(item => item.id === p.id)?.qty || 0} />
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>

          </Grid>
          <MetodoDePagoDialog
            allowMultiple={true}
            open={showPaymentMethodDialog}
            onClose={() => setShowPaymentMethodDialog(false)}
            onConfirm={processSale}
            amount={totals.total}
          />
          <Grid item size={4}>
              <InvoicePanel
                    items={cart}
                    onIncrease={increase}
                    onDecrease={decrease}
                    onRemove={removeItem}
                    totals={totals}
                    priceList={priceList}
                    setPriceList={setPriceList}
                    invoiceType={invoiceType}
                    setInvoiceType={setInvoiceType}
                    client={client}
                    onNewClient={() => setShowClientDialog(true)}
                    shiftOpen={props.shiftOpen}
                    onPaymentMethod={handlePaymentMethod}
              />
          </Grid>
      </Grid>

      <AlertMessageDialog
        open={openAlert}
        handleClose={() => {setOpenAlert(false)}}
        title="Venta procesada exitosamente"
        message="La venta se ha procesado exitosamente"
        severity="success"
      />                
    </>
  );
}
